import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigatorService {

  constructor() { }

  os = [
    { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
    { name: 'Windows', value: 'Win', version: 'NT' },
    { name: 'iPhone', value: 'iPhone', version: 'OS' },
    { name: 'iPad', value: 'iPad', version: 'OS' },
    { name: 'Kindle', value: 'Silk', version: 'Silk' },
    { name: 'Android', value: 'Android', version: 'Android' },
    { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
    { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
    { name: 'Macintosh', value: 'Mac', version: 'OS X' },
    { name: 'Linux', value: 'Linux', version: 'rv' },
    { name: 'Palm', value: 'Palm', version: 'PalmOS' }
  ];

  dataBrowser = [
    { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
    { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
    { name: 'Safari', value: 'Safari', version: 'Version' },
    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
    { name: 'Opera', value: 'Opera', version: 'Opera' },
    { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
  ];

  header = [
    navigator.platform,
    navigator.userAgent,
    navigator.appVersion,
    navigator.vendor
  ];

  public getBrowserDetails(): BrowserAgent {
    var language;	if (window.navigator.languages) {	 language = window.navigator.languages[0];	} else {	 language = window.navigator.language;	}
    return { 
      branchId: '', 
      appCodeName: navigator.appCodeName, 
      appVersion: navigator.appVersion, 
      userAgent: navigator.userAgent, 
      platform: navigator.platform, 
      language: language 
    };
  }

}

export class BrowserAgent {
  public branchId = '';
  public appCodeName = '';
  public appVersion = '';
  public userAgent = '';
  public platform = '';
  public language = '';
}
